var map = {
	"./error.ar-EG": [
		8983,
		983
	],
	"./error.ar-EG.ts": [
		8983,
		983
	],
	"./error.en-US": [
		9091,
		91
	],
	"./error.en-US.ts": [
		9091,
		91
	],
	"./label.ar-EG": [
		9551,
		551
	],
	"./label.ar-EG.ts": [
		9551,
		551
	],
	"./label.en-US": [
		6059,
		59
	],
	"./label.en-US.ts": [
		6059,
		59
	],
	"./page.ar-EG": [
		9962,
		962
	],
	"./page.ar-EG.ts": [
		9962,
		962
	],
	"./page.en-US": [
		1406,
		406
	],
	"./page.en-US.ts": [
		1406,
		406
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9341;
module.exports = webpackAsyncContext;